/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { classes, VComponent } from '@adobe-commerce/elsie/lib';
import '@/quote-management/components/RequestNegotiableQuoteForm/RequestNegotiableQuoteForm.css';

export interface RequestNegotiableQuoteFormProps extends Omit<HTMLAttributes<HTMLFormElement>, 'title'> {
  title: VNode;
  banner?: VNode;
  commentField?: VNode;
  quoteNameField?: VNode;
  attachFile?: VNode;
  attachedFilesList?: VNode;
  requestButton?: VNode;
  saveButton?: VNode;
  onSubmit: (e: Event) => void;
}

export const RequestNegotiableQuoteForm: FunctionComponent<RequestNegotiableQuoteFormProps> = ({
  className,
  title,
  banner,
  commentField,
  quoteNameField,
  attachFile,
  attachedFilesList,
  requestButton,
  saveButton,
  onSubmit,
  ...props
}) => {
  return (
    <form {...props} className={classes(['request-negotiable-quote-form', className])} onSubmit={onSubmit}>
      {banner &&
        <VComponent
          node={banner}
          className={classes(['request-negotiable-quote-form__banner'])}
        />
      }
      {title &&
        <VComponent
          node={title}
          className={classes(['request-negotiable-quote-form__title'])}
        />
      }
      {commentField &&
        <VComponent
          node={commentField}
          className={classes(['request-negotiable-quote-form__comment-field'])}
        />
      }
      {quoteNameField &&
        <VComponent
          node={quoteNameField}
          className={classes(['request-negotiable-quote-form__quote-name-field'])}
        />
      }
      {attachFile &&
        <VComponent
          node={attachFile}
          className={classes(['request-negotiable-quote-form__attach-file-field'])}
        />
      }
      {attachedFilesList &&
        <VComponent
          node={attachedFilesList}
          className={classes(['request-negotiable-quote-form__attached-files-list'])}
        />
      }
      <div className={classes(['request-negotiable-quote-form__actions'])}>
        {requestButton &&
          <VComponent
            node={requestButton}
            className={classes(['request-negotiable-quote-form__request-button'])}
          />
        }
        {saveButton &&
          <VComponent
            node={saveButton}
            className={classes(['request-negotiable-quote-form__save-button'])}
          />
        }
      </div>
    </form>
  );
};
